/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import type { Guardian } from '@whizz/api-model/dist/@types/endpoints/Guardians';
import JungleLayout from '../../../../layouts/JungleLayout';
import React, { useState } from 'react';
import { Translate, useI18n } from '@whizz/react-i18n';
import ChildLoginSection from './modules/ChildLoginSection';
import ParentDataSection from './modules/ParentDataSection';
import ParentConfirmSection from './modules/ParentConfirmSection';
import { Collapse, Stepper } from '../../../../components';
import Whizzy from '../../../../assets/icon-default-whizzy.svg';

enum Sections {
  CHILD = 'CHILD',
  PARENT = 'PARENT',
  CONFIRM = 'CONFIRM',
}

export default function ParentEmailSignUp() {
  const { translate } = useI18n();
  const [ studentToken, setStudentToken ] = useState<string | null>(null);
  const [ mailsToShow, setMailsToShow ] = useState<Guardian['email'][]>([]);

  let sectionToShow: Sections = Sections.CHILD;

  if (!studentToken) {
    sectionToShow = Sections.CHILD;
  } else if (mailsToShow.length <= 0) {
    sectionToShow = Sections.PARENT;
  } else if (mailsToShow.length > 0) {
    sectionToShow = Sections.CONFIRM;
  }
  const stepsObject = Object.keys(Sections);
  return (
    <JungleLayout headerSlot={<Stepper steps={stepsObject.length} activeStep={stepsObject.indexOf(sectionToShow) + 1} showIcons />}>
      <h1 className={'mb-4 text-2xl sm:text-4xl font-bold text-header text-center'}>
        {translate('pages.PARENT_EMAIL_PROCESS.HEADER')}
      </h1>
      <p className='mx-md sm:mx-lg'>
        <Translate i18nKey={'pages.PARENT_EMAIL_PROCESS.SUB'} values={{}}>
          <strong className={'font-bold'} />
          <strong className={'font-bold whitespace-nowrap'}/>
        </Translate>
      </p>
      <hr />
      <div className={'flex justify-end px-10'}>
        <img src={Whizzy} className={'w-16 md:w-20 animate-wiggle'} />
      </div>
      <div>
        <Collapse when={sectionToShow === Sections.CHILD}>
          <ChildLoginSection
            onSuccess={(token) => setStudentToken(token)}
            disabled={null !== studentToken}
          />
        </Collapse>

        <Collapse when={sectionToShow === Sections.PARENT}>
          <ParentDataSection
            disabled={null === studentToken}
            onSuccess={(mails) => setMailsToShow(mails)}
            studentToken={studentToken}
          />
        </Collapse>

        <Collapse when={sectionToShow === Sections.CONFIRM}>
          <ParentConfirmSection
            mailsToShow={mailsToShow}
          />
        </Collapse>
      </div>
    </JungleLayout>
  );
}
